import VerifiedIcon from '@/app/icons/verified'
import Avatar from '@/components/avatar'
import DisplayName from '@/components/display-name'
import Username from '@/components/username'
import { cn } from '@/util/cn'
import { IUser } from '@giphy/js-types'
import Link from 'next/link'

type Props = {
    user: IUser
    className?: string
    avatarSize?: number
    href?: string
}

const Attribution = ({ user, className, avatarSize = 50, href }: Props) => {
    const containerClassName = cn('group flex gap-2.5', className)

    if (href)
        return (
            <Link className={containerClassName} href={href} onClick={(event) => event.stopPropagation()}>
                <Avatar className="pointer-events-none rounded-md" href={href} user={user} size={avatarSize} />
                <div className="flex flex-col justify-center font-semibold">
                    <div className="flex flex-col justify-center font-semibold">{user.display_name}</div>
                    <div
                        className={cn(
                            'flex min-w-0 cursor-pointer items-center gap-1 text-sm font-bold text-giphyWhiteSmoke',
                            'text-giphyWhite/60 group-hover:underline'
                        )}
                    >
                        <div className="overflow-hidden text-ellipsis whitespace-nowrap subpixel-antialiased">
                            @{user.username}
                        </div>
                        {user.is_verified && <VerifiedIcon className="size-3.5 shrink-0 fill-giphyBlue" />}
                    </div>
                </div>
            </Link>
        )

    return (
        <div className={containerClassName}>
            <Avatar className="rounded-md" user={user} size={avatarSize} />
            <div className="flex flex-col justify-center font-semibold">
                <DisplayName user={user} />
                <Username noLink user={user} className="text-giphyWhite/60 group-hover:underline" />
            </div>
        </div>
    )
}

export default Attribution
